
export class MaintenanceRoutineSupplyModel {
  maintenanceRoutineSupplyId: number = 0;
  maintenanceRoutineId: number = 0;
  articleId: number = 0;
  quantityEachUse: number = 0;
  maintenancePlanQuantity1: number = 0;
  maintenancePlanQuantity2: number = 0;
  maintenancePlanQuantity3: number = 0;
  maintenancePlanQuantity4: number = 0;
  maintenancePlanQuantity5: number = 0;
  maintenancePlanQuantity6: number = 0;
  maintenancePlanQuantity7: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}